import get from 'lodash/get';

export const resolveSignature = (signature) => {
    return get(signature, 'type') === 'Buffer'
        ? Buffer.from(signature.data).toString('utf8')
        : signature
};